import React from 'react'
import img2052 from '../components/images/dseo.jpg'
import img2052a from '../components/images/keyword (1).jpg'
import img2052b from '../components/images/content.jpg'
import img2052c from '../components/images/technical.jpg'


const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2052} alt='Seo' />
            </div>
            <div className='container text-center'>
                <h2>Introduction to SEO Your Ultimate Guide to Effective SEO</h2>
                <p>
                    <b> SEO (Search Engine Optimization)</b> is a strategic process aimed at improving a website’s visibility and ranking on search engines like Google. It involves a combination of techniques to attract more organic (non-paid) traffic by ensuring that a site appears higher in search results for relevant queries. SEO encompasses various aspects, including keyword research, content creation, and technical enhancements, to provide a better user experience and meet the algorithms’ criteria that determine search rankings.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Keyword Optimization</b><br />
                            This involves identifying the keywords and phrases that potential visitors are searching for and incorporating them strategically into the website's content, meta descriptions, and headers to improve search engine rankings.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2052a} alt='Queryimg' />
                    </div>
                </div>

                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Quality Content Creation</b><br />
                            Producing valuable, informative, and engaging content that not only answers users' queries but also attracts backlinks from other websites. High-quality content helps to establish authority and trust, which are crucial factors for search engine ranking.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2052b} alt='Queryimg' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Technical SEO</b><br />
                            This includes optimizing the website's technical aspects, such as ensuring fast page load times, creating a mobile-friendly design, improving site structure and navigation, and using proper HTML tags. These improvements make it easier for search engines to crawl and index the site, which can enhance visibility and user experience.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img2052c} alt='Queryimg' />
                    </div>
                </div >

            </div>

        </>
    )
}

export default events